// extracted by mini-css-extract-plugin
module.exports = {"generalMessage":"lJJDd2CR1zmN8041vlYST","icon":"DZKteid1MUv69FI_gnmzo","success":"_19pFjVyIp8SlG9O7gsBjO5","warning":"_3H9OpcQpBLVMmWpoI1n7Ef","error":"_3fcXLHatrz3X10v4EyKdsO"};